import { Observable } from 'rxjs';

export abstract class AbstractFavoritesMenuNotifierService {
  abstract readonly favoritesListCreatedForArticle$: Observable<{ globalArticleId: string; listId: string }>;
}
